module.exports = __webpack_public_path__ + "static/media/can.44aae3b5.svg";